/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelEdis.ts                          *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/datafusion/edis";

export class AutogenModelEdis<RowType extends ModelRow> extends Endpoint<RowType, RowEdisFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowEdis extends ModelRow<RowEdisFields> {
	constructor(values?: Partial<RowEdisFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowEdisFields {
	comment_type: string;
	comments: string;
	company_id: string;
	edistatus_id: string;
	id: string;
	is_callin: string;
	sequence: number;
}

